export default __webpack_public_path__ + "static/media/project_cadefi_1.61b9143f.png";